import { api } from "../../../services/api";
import { TRADE_BOARDCAST_RIGHT_BAR_ACTIONS } from "../../actionType/TradeBoardCast";
import { tradeBoardCast } from "../../../services/apiVariables";
import { Toast } from "../../../services/toast";

export const getTradeBoardCastRightBar =
    (body: any) => (dispatch: (arg0: { type: string; payload: any }) => void) => {
        dispatch({
            type: TRADE_BOARDCAST_RIGHT_BAR_ACTIONS.TRADE_BOARDCAST_RIGHT_BAR_ACTIONS_REQUEST,
            payload: { isFollowBondLoader: true },
        });
        return new Promise((resolve, reject) => {
            api({ ...tradeBoardCast.get, body })
                .then((data: any) => {
                    console.log('getTradeBoardCastRightBar', data?.data);

                    if (data.code === 200) {
                        dispatch({
                            type: TRADE_BOARDCAST_RIGHT_BAR_ACTIONS.TRADE_BOARDCAST_RIGHT_BAR_ACTIONS_RESPONSE,
                            payload: data?.data,
                        });
                    }
                    resolve(data?.data);
                })
                .catch((error) => {
                    dispatch({ type: TRADE_BOARDCAST_RIGHT_BAR_ACTIONS.TRADE_BOARDCAST_RIGHT_BAR_ACTIONS_ERROR, payload: [] });
                    resolve(error);
                });
        });
    };